import { resolveReservedHeight } from './scrollStability'

export const MIN_ROW_GEOMETRY_HEIGHT = 1

export const toPositiveRowGeometryNumber = value => {
    const number = Math.ceil(Number(value || 0))
    return Number.isFinite(number) && number > 0 ? number : null
}

export const resolveInitialRowGeometry = ({
    rememberedHeight = 0,
    estimatedHeight = 0,
    minHeight = MIN_ROW_GEOMETRY_HEIGHT,
} = {}) => {
    const minimumHeight = toPositiveRowGeometryNumber(minHeight) || MIN_ROW_GEOMETRY_HEIGHT
    const remembered = toPositiveRowGeometryNumber(rememberedHeight)
    const estimated = toPositiveRowGeometryNumber(estimatedHeight)
    const hasRememberedHeight = Boolean(remembered)

    return {
        height: Math.max(minimumHeight, hasRememberedHeight ? remembered : estimated || 0),
        hasRememberedHeight,
    }
}

// Retained geometry is measurement memory for estimates/placeholders; rendered
// virtual rows still let React Virtual own the live row box.
export const resolveRetainedRowGeometry = ({
    measuredHeight = 0,
    previousHeight = 0,
    previousMeasuredHeight = 0,
    hasMeasuredHeight = false,
    preserveHeight = false,
    allowShrink = false,
    minHeight = MIN_ROW_GEOMETRY_HEIGHT,
    normalizeHeight = null,
} = {}) => {
    const minimumHeight = toPositiveRowGeometryNumber(minHeight) || MIN_ROW_GEOMETRY_HEIGHT
    const reservedHeight = resolveReservedHeight({
        measuredHeight,
        previousHeight,
        previousMeasuredHeight,
        hasMeasuredHeight,
        preserveHeight,
        allowShrink,
        minHeight: minimumHeight,
    })
    const normalizedHeight =
        typeof normalizeHeight === 'function' ? normalizeHeight(reservedHeight) : reservedHeight
    const retainedHeight = toPositiveRowGeometryNumber(normalizedHeight)

    return retainedHeight ? Math.max(minimumHeight, retainedHeight) : null
}

export const resolveRowGeometryFrameStyle = ({
    intrinsicHeight = MIN_ROW_GEOMETRY_HEIGHT,
    shouldRender = false,
    minHeight = MIN_ROW_GEOMETRY_HEIGHT,
    heightVariable = null,
    heightVariableMode = 'always',
    renderedHeightMode = 'none',
    placeholderHeightMode = 'height',
} = {}) => {
    const height = Math.max(
        toPositiveRowGeometryNumber(minHeight) || MIN_ROW_GEOMETRY_HEIGHT,
        toPositiveRowGeometryNumber(intrinsicHeight) || MIN_ROW_GEOMETRY_HEIGHT,
    )
    const style = {}
    const shouldApplyHeightVariable =
        heightVariable &&
        (heightVariableMode === 'always' ||
            (heightVariableMode === 'rendered' && shouldRender) ||
            (heightVariableMode === 'placeholder' && !shouldRender))
    if (shouldApplyHeightVariable) style[heightVariable] = `${height}px`

    const mode = shouldRender ? renderedHeightMode : placeholderHeightMode
    if (mode === 'height') style.height = height
    if (mode === 'minHeight') style.minHeight = height

    return style
}
